export default { sha: '7ac776a1e416e407a5b0c5008967d70343aa2344', buildNumber: 'undefined' }
